var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getCachedValue, updateCachedValue } from '../../components/finance/services/crs/cache';
import { createCrsLogger } from '../../components/finance/services/crs/helpers';
import { updateFinanceInStore } from '../utils/sessionStorage';
function getData(_a) {
    return __awaiter(this, arguments, void 0, function* ({ url, request, requestedData, vehicleId, vehicleType, trackingService, useCache, }) {
        const crsLogger = createCrsLogger(vehicleId, requestedData);
        crsLogger.debug(`fetching data : useCache ${useCache}`);
        let result;
        if (useCache) {
            result = getCachedValue(crsLogger, vehicleId, requestedData);
        }
        if (!result) {
            const requestData = { Request: Object.assign(Object.assign({}, request), { '@Name': requestedData }) };
            try {
                result = yield crsRequest(crsLogger, trackingService, url, requestData);
                if (vehicleId) {
                    updateFinanceInStore(vehicleId, vehicleType, requestData, result);
                }
                if (useCache) {
                    updateCachedValue(crsLogger, vehicleId, requestedData, result);
                }
            }
            catch (error) {
                updateFinanceInStore(vehicleId, vehicleType);
                const errorMsg = error.message ? error.message.replace('Error: ', '') : '';
                throw new Error(errorMsg);
            }
        }
        return result === null || result === void 0 ? void 0 : result.Response;
    });
}
export function getProducts(url_1, request_1, vehicleId_1, vehicleType_1, trackingService_1) {
    return __awaiter(this, arguments, void 0, function* (url, request, vehicleId, vehicleType, trackingService, useCache = true) {
        return getData({
            url,
            request,
            requestedData: 'Products',
            vehicleId,
            vehicleType,
            trackingService,
            useCache,
        });
    });
}
export function getDefaultProduct(url_1, request_1, vehicleId_1, vehicleType_1, trackingService_1) {
    return __awaiter(this, arguments, void 0, function* (url, request, vehicleId, vehicleType, trackingService, useCache = true) {
        return getData({
            url,
            request,
            requestedData: 'Defaults',
            vehicleId,
            vehicleType,
            trackingService,
            useCache,
        });
    });
}
export function crsRequest(crsLogger, trackingService, url, requestData) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        crsLogger.debug(`fetching data from server at ${url}`);
        const response = yield fetch(url, {
            body: JSON.stringify(requestData),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            method: 'POST',
        });
        const json = yield response.json();
        if (isErrorResponse(json)) {
            const errorDetails = (_b = (_a = json.Response) === null || _a === void 0 ? void 0 : _a.Error) !== null && _b !== void 0 ? _b : (_c = json.Response) === null || _c === void 0 ? void 0 : _c.Errors;
            const { errDes, errObj } = generateErrorMessage(errorDetails);
            crsLogger.warn('got error response from server', errDes);
            trackingService === null || trackingService === void 0 ? void 0 : trackingService.track({
                event: {
                    eventInfo: {
                        eventAction: 'error',
                        eventName: 'vtp finance calculation error',
                    },
                    attributes: {
                        componentName: 'vtp-carInfo',
                        label: '',
                        targetUrl: '',
                        clickID: '',
                        elementName: '',
                        value: '',
                        pos: '',
                    },
                    error: {
                        name: errObj['@Class'],
                        codeInternal: errObj['@Code'],
                        type: errObj['@ErrorType'],
                        source: errObj['@Source'],
                        message: errDes || (errObj === null || errObj === void 0 ? void 0 : errObj.Description) || errObj['#text'] || '',
                    },
                },
            });
            throw new Error(errDes);
        }
        crsLogger.debug('got data from server', json);
        return json;
    });
}
function generateErrorMsgFromArr(errorList) {
    var _a;
    let errDesc = '';
    const errorUserType = errorList.filter((error) => error['@ErrorType'] === 'User');
    errDesc = errorUserType === null || errorUserType === void 0 ? void 0 : errorUserType.reduce((acc, err) => {
        return err.Description ? acc + (acc ? '<br /><br />' : '') + err.Description : acc;
    }, '');
    return {
        errObj: (_a = errorUserType[0]) !== null && _a !== void 0 ? _a : {},
        errDes: errDesc || '',
    };
}
function generateErrorMessage(errorDetails) {
    var _a, _b, _c;
    if (Array.isArray(errorDetails) || Array.isArray(errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.Error)) {
        const errParam = (_a = errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.Error) !== null && _a !== void 0 ? _a : errorDetails;
        return generateErrorMsgFromArr(errParam);
    }
    if (typeof errorDetails.Description === 'object') {
        return {
            errObj: errorDetails,
            errDes: errorDetails['@ErrorType'] === 'User' ? errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.Description['#text'] : '',
        };
    }
    if (typeof errorDetails === 'object') {
        return {
            errObj: errorDetails,
            errDes: ((_b = errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.Error) === null || _b === void 0 ? void 0 : _b['@ErrorType']) === 'User' ? (_c = errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.Error) === null || _c === void 0 ? void 0 : _c.Description : '',
        };
    }
    return {
        errObj: errorDetails,
        errDes: errorDetails['@ErrorType'] === 'User'
            ? errorDetails.Description || errorDetails['#text'] || ''
            : '',
    };
}
function isErrorResponse(responseData) {
    return (!responseData ||
        !responseData.Response ||
        !!responseData.Response.Error ||
        !!responseData.Response.Errors);
}
